// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ms12","modalFooterButton":"ModalNotes_modalFooterButton__2R2dg"};